<template>
  <div>
    <el-table
        ref="multipleTable"
        :data="infoList"
        tooltip-effect="dark"
        style="width: 100%"
        border
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          label="商品图片"
          prop="thumb"
          width="90">
          <template slot-scope="scope">
            <el-image
                  style="width: 40px; height: 40px"
                  :src="scope.row.thumb"
                  fit="cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsName"
          label="商品名称"
          width="180">
        </el-table-column>
        <el-table-column
          prop="specName"
          label="商品规格">
        </el-table-column>
        <el-table-column
          prop="goodsNumber"
          label="商品数量">
        </el-table-column>
      </el-table>
      <div class="mt-goods-margin">
        <el-button @click="saveBtn" type="primary" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
      </div>
  </div>
</template>

<script>
import { queryOrderGoodsInfoByOrderId } from '@/api/order'
export default {
  name: 'GoodsList',
  props: {
    infoId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      infoList: [],
      multipleSelection: []
    }
  },
  mounted () {
    this.detailInfoFun();
  },
  methods: {
    /* 商品订单中购买的商品信息 */
    detailInfoFun(){
      var that = this;
      queryOrderGoodsInfoByOrderId({orderId:that.infoId}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.infoList = data;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /* 保存操作 */
    saveBtn(){
      var multipleSelection = this.multipleSelection;
      console.log(multipleSelection);
      this.$emit('choosedGoodsData', multipleSelection);
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/GoodsList.vue